import { FC } from 'react'
import clsx from 'clsx'
import styled, { css } from 'styled-components'
import { Button } from 'components/custom-material-ui'
import { PaginatorPiece, State } from 'hooks/usePagination'
import ArrowLeftIcon from 'svgIcons/ArrowLeft'
import ArrowRightIcon from 'svgIcons/ArrowRight'

interface PaginationProps {
  pagination: Pick<State, 'visiblePieces' | 'activePage' | 'goToPage'>
}

const Pagination: FC<PaginationProps> = ({ pagination }) => {
  const { visiblePieces, activePage, goToPage } = pagination

  function renderVisiblePiece(piece: PaginatorPiece) {
    if (piece.type === 'next')
      return (
        <Button
          key="next"
          className="button-arrow-next"
          disabled={piece.isDisabled}
          onClick={() => goToPage(piece.pageNumber)}
        >
          <ArrowRightIcon className="icon-arrow" />
        </Button>
      )
    if (piece.type === 'previous')
      return (
        <Button
          key="previous"
          className="button-arrow-previous"
          disabled={piece.isDisabled}
          onClick={() => goToPage(piece.pageNumber)}
        >
          <ArrowLeftIcon className="icon-arrow" />
        </Button>
      )

    if (piece.type === 'page-number') {
      return (
        <Button
          key={piece.pageNumber}
          className={clsx('button-page-number', {
            'active-page': activePage === piece.pageNumber,
          })}
          onClick={() => goToPage(piece.pageNumber)}
        >
          {piece.pageNumber}
        </Button>
      )
    }

    return null
  }

  return <StyledWrapper>{visiblePieces.map(renderVisiblePiece)}</StyledWrapper>
}

export default Pagination

const StyledWrapper = styled.div`
  padding-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding-top: 20px;
      background-color: #fafafa;
    `}

  .button-arrow {
    &-next {
      padding-bottom: 11px;
      padding-top: 12px;
      margin-left: 10px;
    }

    &-previous {
      padding-bottom: 11px;
      padding-top: 12px;
      margin-right: 10px;
    }

    &-next,
    &-previous {
      .icon-arrow {
        width: 9px;
        height: 16px;
      }
    }
  }

  .button-page-number {
    line-height: 1;
    font-size: 15px;
    padding-bottom: 11px;
    padding-top: 12px;
    margin-left: 0;
    margin-right: 0;
    padding-left: 10px;
    padding-right: 10px;
    background-color: transparent;
    color: #dddddd;
    font-weight: 500;
    &:hover {
      background-color: transparent;
    }

    ${({ theme }) =>
      theme.isMobile &&
      css`
        margin-left: 5px;
        margin-right: 5px;
      `}

    &.active-page {
      color: ${({ theme }) => theme.color.primary_2};
    }
  }
`
